import React, {useEffect, useRef, useState} from "react";
import {Accordion, AccordionTab} from "primereact/accordion";
import {InputText} from "primereact/inputtext";
import classes from "./SparqlQuery.module.css";
import {Button} from "primereact/button";
import {InputTextarea} from "primereact/inputtextarea";
import {FileUpload} from "primereact/fileupload";
import {generateRandomKey} from "../../../../api/utils/Random";
import {adaptQueryName, sparqlExtensions} from "../../../../api/utils/SparqlQueries";
import {showError} from "../../../../api/notification/ToastManager";
import EditQueryDialog from "./EditQueryDialog";
import {removeNonUtf8} from "../../../../api/utils/Strings";


const SparqlQueryPythonScript = ({
                                     deleteCurrentQuery,
                                     updateCurrentQuery,
                                     readOnly,
                                     currentQuery,
                                     error,
                                     identifier
                                 }) => {
    const fileUploadRef = useRef(null);
    const [errorMessage, setErrorMessage] = useState("")
    const [fileName, setFileName] = useState("Choose File");
    const [isEditQueryVisible, setIsEditQueryVisible] = useState(false);

    const close = () => {
        setIsEditQueryVisible(false)
    }
    useEffect(() => {
        setErrorMessage(error)
    }, [error]);
    useEffect(() => {
        if (currentQuery.sparqlParameters.length === 0) {
            updateCurrentQuery({
                ...currentQuery,
                sparqlParameters: [{name: '', key: generateRandomKey(), properties: {}}]
            })
        }
    }, [currentQuery])

    const warningMsg = "This query currently have " + currentQuery['executions']?.length + " executions !"
    const warningDeleteQuery = currentQuery['executions']?.length !== 0 && currentQuery['executions']?.length !== undefined ? warningMsg : "";

    const getFileContext = async (event) => {
        const name = event.files[0].name
        const tm = name.split('.')
        if (sparqlExtensions.includes(tm[tm.length - 1])) {
            const reader = new FileReader()
            reader.onload = async (e) => {
                const text = (e.target.result)
                checkFileContent(text, name)
            };
            reader.readAsText(event.files[0], 'UTF-8')
        } else {
            clearFileContextWithErrorToast("Unsupported file extension", "The Query file extension is not valid. Possible extensions : (" + sparqlExtensions.join(" ,") + " ).")
        }
    }

    const checkFileContent = (text, name) => {
        if (text.length > 0) {
            updateCurrentQuery({...currentQuery, content: removeNonUtf8(text)})
            setFileName(name)
            fileUploadRef.current.clear();
        } else {
            clearFileContextWithErrorToast("Empty file content", "The Query file content is empty")
        }
    }

    const clearFileContextWithErrorToast = (summary, message) => {
        setFileName("Choose File")
        fileUploadRef.current.clear();
        showError(summary, message)

    }

    const handleInputChange = (value) => {
        const filteredValue = value.replace(/[^a-zA-Z0-9_-]/g, '');
        updateCurrentQuery({
            ...currentQuery,
            name: adaptQueryName(filteredValue)
        })
    };

    return (
        <div>
            <br/>
            <div className="grid">
                <div className="col-12">
                    <Accordion activeIndex={readOnly ? -1 : 0}>
                        <AccordionTab header={`${currentQuery.name}`}>
                            <div className="grid">
                                <div className="col-6">
                                    <p><b>Name</b></p>
                                    <div className="flex align-items-center gap-2">
                                        <InputText name="name"
                                                   value={currentQuery.name}
                                                   className={classes.inputStyle}
                                                   placeholder="Your Query name ..."
                                                   onChange={(event) =>
                                                       handleInputChange(event.target.value)}
                                                   disabled={readOnly}
                                                   style={{flex: 1}}
                                        />

                                        {
                                            readOnly && (
                                                <Button type="button"
                                                        className={classes.customButton}
                                                        tooltip={`Edit <${currentQuery.name}>`}
                                                        icon="pi pi-pencil"
                                                        onClick={() => setIsEditQueryVisible(true)}
                                                />
                                            )}

                                        {currentQuery.queryType === "SparQLQuery" &&
                                            <FileUpload mode="basic" name="demo[]"
                                                        ref={fileUploadRef}
                                                        tooltip={"upload new Query"}
                                                        accept="application/text"
                                                        className={classes.uploadBtn}
                                                        onSelect={getFileContext}
                                                        chooseLabel={fileName}
                                            />}
                                    </div>

                                    <p><b>Description</b></p>
                                    <InputTextarea name="description"
                                                   rows={5}
                                                   cols={30}
                                                   autoResize
                                                   className={classes.inputStyle}
                                                   value={`${currentQuery.description}`}
                                                   placeholder={"Please provide a description of this query to help users ..."}
                                                   onChange={event => {
                                                       updateCurrentQuery({
                                                           ...currentQuery,
                                                           description: event.target.value
                                                       })
                                                   }}
                                    />
                                </div>
                                <div className="col-12 mt-3">
                                    <Button type="button" className={classes.customButton} icon="pi pi-trash"
                                            onClick={() => {
                                                setFileName("Choose File")
                                                deleteCurrentQuery()
                                            }}
                                            tooltip={warningDeleteQuery} tooltipOptions={{position: 'bottom'}}
                                    />
                                    {errorMessage === '' ? null :
                                        <small style={{whiteSpace: "pre-wrap"}}>{errorMessage}</small>}
                                </div>
                            </div>
                        </AccordionTab>

                    </Accordion>
                </div>
            </div>
            <EditQueryDialog currentQuery={currentQuery}
                             isEditQueryVisible={isEditQueryVisible}
                             saveDesc={(text) => {
                                 currentQuery.content = removeNonUtf8(text);
                                 updateCurrentQuery(currentQuery);
                                 close();
                             }}
                             closeDialog={(_) => {
                                 close();
                             }}
            />
        </div>
    )
}

export default SparqlQueryPythonScript;
